import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Idle from 'react-idle-timer';
import CustomerSearchPage from './pages/CustomerSearchPage'
import Dashboard from './pages/Dashboard';
import CustomerActivityPage from './pages/CustomerActivityPage'
import CreateCustomerPage from './pages/CreateCustomerPage';
import LoginPage from './pages/LoginPage';
import UserStorage from './utility/UserStorage';
import InvoicesSearch from './components/Invoice/invoices-search/InvoicesSearch';
import config from './clientConfig';
import Profile from './pages/Profile/Profile';

const styles = {
  root: {
    height: '100vh',
    width: '100vw'
  }
};

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    UserStorage.isAuthenticated() === true
      ? (<div className="private-route">
        <Idle timeout={config.idleTimeoutInMilliseconds} onIdle={() => {
          console.log('session expired....logging out');
          window.location = '/login'
        }} />
      <Component {...props} />
  </div>)
      : <Redirect to={{
          pathname: '/login',
          state: { from: props.location }
        }} />
  )} />
)

const Main = ({setIsAuthenticated}) => (
  <main style={styles.root}>
    <Switch>
      <Route exact path='/login' render={(props) => <LoginPage {...props} setIsAuthenticated={setIsAuthenticated}/>} />      
      <PrivateRoute exact path='/customerSearch' component={CustomerSearchPage}/>
      <PrivateRoute exact path='/dashboard' component={Dashboard}/>
      <PrivateRoute exact path='/createCustomer' component={CreateCustomerPage}/>
      <PrivateRoute path="/customer/:customerId" component={CustomerActivityPage}/>
      <PrivateRoute path="/search/invoices" component={InvoicesSearch}/>
      <PrivateRoute path="/profile" component={Profile}/>      
      <Redirect from="/" to="/dashboard"/>
      <Redirect to="/dashboard" />
    </Switch>
  </main>
)

export default Main
